import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import nl from '../locales/nl.json'
import en from '../locales/en.json'
import fr from '../locales/fr.json'
import de from '../locales/de.json'

export const languages = ['nl', 'en', 'fr', 'de']
export function resolveLanguage(value) {
  const language = value?.toLowerCase().split('-')[0]
  return languages.includes(language) ? language : 'en'
}

let preferred
try { preferred = localStorage.getItem('heliview.language') } catch { /* Storage can be unavailable in a Teams frame. */ }
i18n.use(initReactI18next).init({
  resources: { nl: { translation: nl }, en: { translation: en }, fr: { translation: fr }, de: { translation: de } },
  lng: resolveLanguage(preferred || navigator.language),
  supportedLngs: languages,
  fallbackLng: 'en',
  keySeparator: false,
  nsSeparator: false,
  initAsync: false,
  interpolation: { escapeValue: false },
})
document.documentElement.lang = i18n.language
i18n.on('languageChanged', language => {
  document.documentElement.lang = language
  try { localStorage.setItem('heliview.language', language) } catch { /* Keep the selection in memory when storage is unavailable. */ }
})
export const t = (...args) => i18n.t(...args)
export { i18n }
